import React from 'react';
import { Spinner } from 'react-bootstrap';
import { CheckCircle, Cloud } from 'lucide-react';
import { WORK_ORDER_LABELS } from '../../workOrderSections';
import './shared.css';

export type AutosaveState = 'idle' | 'saving' | 'saved';

export interface AutosaveIndicatorProps {
    state: AutosaveState;
    className?: string;
}

/** "Sparas automatiskt / Sparar… / Sparat" status line (look lifted from the guest page). */
export const AutosaveIndicator: React.FC<AutosaveIndicatorProps> = ({ state, className }) => (
    <div
        className={`wo-autosave small text-muted${className ? ` ${className}` : ''}`}
        role="status"
        aria-live="polite"
    >
        {state === 'saving' && (
            <>
                <Spinner animation="border" size="sm" /> {WORK_ORDER_LABELS.autosaveSaving}
            </>
        )}
        {state === 'saved' && (
            <>
                <CheckCircle size={16} className="text-success" /> {WORK_ORDER_LABELS.autosaveSaved}
            </>
        )}
        {state === 'idle' && (
            <>
                <Cloud size={16} /> {WORK_ORDER_LABELS.autosaveIdle}
            </>
        )}
    </div>
);

export default AutosaveIndicator;
